<div>
  <h3 class="!m-0 !font-bold">Conditions</h3>
  <div class="text-sm text-slate-500">
    The following conditions must be met for this automation to run. If they are
    not met the automation will be skipped.
  </div>
</div>

<div class="flex flex-col gap-1">
  @for (
    conditionGroup of conditionsGroups();
    track groupIndex;
    let groupIndex = $index;
    let isLastGroup = $last
  ) {
    <div class="flex flex-col gap-1 rounded bg-slate-100 p-4 text-slate-500">
      @for (
        condition of conditionGroup;
        track conditionIndex;
        let conditionIndex = $index;
        let isLastCondition = $last
      ) {
        <div>
          {{ condition }}
        </div>
        @if (!isLastCondition) {
          <div class="flex flex-row items-center gap-4">
            <div class="flex grow border-t border-solid border-slate-200"></div>
            <div class="text-sm !font-bold text-slate-300">AND</div>
            <div class="flex grow border-t border-solid border-slate-200"></div>
          </div>
        }
      }
    </div>
    @if (!isLastGroup) {
      <div class="flex flex-row items-center gap-4">
        <div class="flex grow"></div>
        <div class="text-sm !font-bold text-slate-300">OR</div>
        <div class="flex grow"></div>
      </div>
    }
  }
</div>
